import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Box,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  useMediaQuery
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useTheme } from "@mui/material/styles";
import { useNavigate, useLocation } from "react-router-dom";
import myImage from "./assets/MyImg/LoginImgy.png";

const HeaderSection = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeIndex, setActiveIndex] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md")); // mobile and tablet

  const menuItems = [
    { label: "Invoice", link: "/invoice" },
    { label: "Bill", link: "/bill" },
    { label: "Report", link: "/report" },
    { label: "Product", link: "/product" },
    { label: "Set Product", link: "/set-product" },
    { label: "Update Product", link: "/up-product" },
    { label: "Admin", link: "/admin-login" }
  ];

  useEffect(() => {
    const currentIndex = menuItems.findIndex(item => item.link === location.pathname);
    setActiveIndex(currentIndex);
  }, [location.pathname, menuItems]); // Added 'menuItems' to the dependency array

  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  return (
    <Box sx={{ bgcolor: "#fff", minHeight: "85px", width: "100%" }}>
      <AppBar position="static" sx={{ bgcolor: "#3D3D3D", boxShadow: "none" }}>
        <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
          {/* Left - Logo */}
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <img
              src={myImage}
              alt="Login Logo"
              style={{
                width: "90px",
                height: "70px",
                borderRadius: "8px",
                marginLeft: "20px",
                position: "relative",
                marginBottom: "10px"
              }}
            />
          </Box>

          {/* Right - Menu or Buttons */}
          {isMobileOrTablet ? (
            <>
              <IconButton
                edge="end"
                color="inherit"
                onClick={toggleDrawer(true)}
                sx={{ mr: 2 }}
              >
                <MenuIcon />
              </IconButton>
              <Drawer
                anchor="right"
                open={drawerOpen}
                onClose={toggleDrawer(false)}
              >
                <Box
                  sx={{ width: 250 }}
                  role="presentation"
                  onClick={toggleDrawer(false)}
                  onKeyDown={toggleDrawer(false)}
                >
                  <List>
                    {menuItems.map((item, index) => (
                      <ListItem key={item.label} disablePadding>
                        <ListItemButton onClick={() => navigate(item.link)}>
                          <ListItemText
                            primary={item.label}
                            primaryTypographyProps={{
                              fontWeight: activeIndex === index ? "bold" : "normal",
                              color: activeIndex === index ? "#20a4a5" : "#000"
                            }}
                          />
                        </ListItemButton>
                      </ListItem>
                    ))}
                  </List>
                </Box>
              </Drawer>
            </>
          ) : (
            <Box sx={{ display: "flex", gap: 2 }}>
              {menuItems.map((item, index) => (
                <Button
                  key={index}
                  color="inherit"
                  onClick={() => navigate(item.link)}
                  sx={{
                    fontSize: "18px",
                    fontFamily: "caladea",
                    textTransform: "none",
                    width: "150px",
                    height: "65px",
                    marginTop: '5px',
                    bgcolor: activeIndex === index ? "#20a4a5" : "#3D3D3D",
                    borderTopLeftRadius: "15px",
                    borderTopRightRadius: "15px",
                    borderBottomLeftRadius: "0px",
                    borderBottomRightRadius: "0px"
                  }}
                >
                  {item.label}
                </Button>
              ))}
            </Box>
          )}
        </Toolbar>
      </AppBar>
    </Box>
  );
};

export default HeaderSection;